// src/modules/app-views/_apps/appmulti/operators/pages/Document/actions/actionButton.js

import { SaveOutlined } from '@ant-design/icons';

const operatorsDocumentActionButton = () => {
  return {
    action: 'save',
    hideButton: false,
    label: 'save',
    tooltip: 'save_document',
    icon: <SaveOutlined />,
    type: 'primary',
    disabled: false,
    onClick: ({ moduleContext }) => moduleContext?.formContext?.submitForm?.(),
    dropdownItems: [],
  };
};

export default operatorsDocumentActionButton;
